module.exports = MaterialUI.InputLabel;